import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useNFLDemoOptional } from '@/contexts/NFLDemoContext';

interface NFLWeekSelectorProps {
  currentWeek: number;
  selectedWeek: number;
  onWeekChange: (week: number) => void;
  maxWeek?: number;
}

export default function NFLWeekSelector({ currentWeek, selectedWeek, onWeekChange, maxWeek = 18 }: NFLWeekSelectorProps) {
  const demo = useNFLDemoOptional();

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 min-h-[44px] min-w-[44px] text-muted-foreground hover:text-foreground"
        disabled={selectedWeek <= 1}
        onClick={() => onWeekChange(selectedWeek - 1)}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>

      <button
        onClick={() => onWeekChange(currentWeek)}
        className={cn(
          'text-xs font-medium px-2 py-1.5 rounded-md transition-colors min-h-[44px] flex items-center',
          selectedWeek === currentWeek
            ? 'bg-primary/10 text-primary border border-primary/20'
            : 'text-muted-foreground hover:text-foreground'
        )}
      >
        Week {selectedWeek}
        {selectedWeek === currentWeek && !demo?.isDemoMode && (
          <span className="ml-1 text-[10px] text-primary/60">LIVE</span>
        )}
      </button>

      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 min-h-[44px] min-w-[44px] text-muted-foreground hover:text-foreground"
        disabled={selectedWeek >= maxWeek}
        onClick={() => onWeekChange(selectedWeek + 1)}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
